import React from "react";
import PropTypes from "prop-types";

import { Icon } from "../Icon";

import styles from "./UspTeaser.scss";

function TeaserHeader({ children, icon }) {
  return (
    <div className={styles.teaserTileHeader}>
      <span className={styles.iconWrapper}>
        <Icon
          icon={icon}
          size={Icon.Size.parent}
          wrapperProps={{ style: { width: "100%" } }}
        />
      </span>
      <span className={styles.headline}>{children}</span>
    </div>
  );
}

TeaserHeader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  icon: PropTypes.elementType.isRequired,
};

TeaserHeader.displayName = "UspTeaser.TileHeader";

export default TeaserHeader;
